import * as actionTypes from '../actions/actionTypes';

export default function productDetailsReducer(state = { account: [], echannel: [], gls: [], achCredit: [], additionalData: [], cashFlowForecasting: [] }, action) {
  switch (action.type) {
    case actionTypes.SET_PRODUCTS_DETAILS: {
      return action.productsDetailsdata;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/productDetailsReducer.js